import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  unavailable: {
    id: 'pd.variants.tile.unavailable',
    defaultMessage: 'Nedostupné',
  },
});
